import { Chart, registerables } from "chart.js"
import React from "react";
import { Line } from "react-chartjs-2";
import { PositionsState } from './ParamSettings';
import { useRecoilValue } from "recoil";

Chart.register(...registerables)

const { faker } = require('@faker-js/faker');

function Graph() {
  const positions = useRecoilValue(PositionsState);
  //const labels = ["1 月", "2 月", "3 月", "4 月", "5 月", "6 月"];
  let labels: Date[] = [];
  for (let i=1; i<=31; i++) {
    labels.push(new Date(2023, 0, i));
  }
  for (let i=1; i<=28; i++) {
    labels.push(new Date(2023, 1, i));
  }
  for (let i=1; i<=31; i++) {
    labels.push(new Date(2023, 2, i));
  }

  const getDatasets = () => {
    const colors = [ "rgb(75, 192, 192)", "rgb(0, 0, 250)", "rgb(0, 250, 250)" ]
    return positions.map((pos, index) => { return {
      label: pos,
      data: labels.map(() => faker.datatype.number({ min:-10, max:10 })),
      borderColor: colors[index],
      borderWidth: 1,
      pointRadius: 1
    }})
  };

  const graphData = {
    labels: labels.map(t => t.toLocaleString()),
    
    datasets: [...getDatasets()]
  };

  const options: {} = {
    maintainAspectRatio: false,
      scales: {y: { title: { display: true, text: 'Mw [*10^6 kNm]' }}}
  };

  const divStyle: React.CSSProperties = {
    marginLeft: "auto",
    marginRight: "auto",
    margin: "10px",
    width: "100%",
    height: "500px",
    position: "relative"
  };

  return (
    <div className="App" style={divStyle}>
      <Line
        data={graphData}
        options={options}
        id="chart-key"
      />
    </div>
  );
}

export default Graph;
